export const REQUESTOR_KEY = 'requestor';
export const SHOP_CATEGORY_STORAGE_KEY = 'shopCategoryFormData';
export const USER_DATA_KEY = 'user_data';
